import { PersistentStorage } from "../local-storage/persistent-storage";

export const SessionStorage = new PersistentStorage(sessionStorage);
